import { FC, useEffect, useState } from 'react';
import { ExtendedGridColDef } from '@/types/ExtendedGridColDef';
import { Grid, Tooltip, Switch, IconButton, Menu, MenuItem, Box } from '@mui/material';
import { SCUIContent } from '../../atomic/organisms';
import { SCUICustomDataGrid, SCUIGeneralDrawer } from '../../atomic/molecules';
import { CookieManagementQuery } from '../../services/query';
import { useTranslation } from 'react-i18next';
import { SCUICookieManagementDrawerContent } from './components/SCUICookieManagementDrawerContent';
import { SCUIButton } from '../../atomic/atoms';
import TimeHelper from '../../utils/time';
import Swal from 'sweetalert2';
import { CookieManagementCommand } from '../../services/command';
import AndroidIcon from '@mui/icons-material/Android';
import AppleIcon from '@mui/icons-material/Apple';
import PopupState, { bindMenu, bindTrigger } from 'material-ui-popup-state';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { CKM, ckmCls } from './cookieManagement.classes';

export const CookieManagement: FC<any> = () => {
    const { t } = useTranslation();
    const [state, setState] = useState({
        right: false,
    });
    const [cookie, setCookie] = useState([]);
    const [cookieTypeIdsAndNames, setCookieTypeIdsAndNames] = useState<any>([]);
    const [selectedCookie, setSelectedCookie] = useState<any>();
    const onDrawerOpen = () => setState({ ...state, right: true });
    const onDrawerClose = () => setState({ ...state, right: false });
    const [refresh, setRefresh] = useState(false);

    const refreshSmsTemplate = () => {
        setRefresh((prevLoading) => !prevLoading);
    };

    useEffect(() => {
        GetCookie();
    }, [refresh]);

    useEffect(() => {
        GetCookieType();
    }, []);
    const columns: ExtendedGridColDef[] = [
        {
            field: 'cookieName',
            headerName: 'Çerez Adı',
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: (params: any) => {
                return (
                    <div>
                        <Tooltip title={params.row.cookieName}>
                            <p>{params.row.cookieName}</p>
                        </Tooltip>
                    </div>
                );
            },
        },
        {
            field: 'cookieType',
            headerName: 'Çerez Tipi',
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params: any) => {
                const cookieTypeName =
                    cookieTypeIdsAndNames.find((ct: any) => ct.id === params.row.cookieType)?.name || '-';
                return cookieTypeName;
            },
        },
        {
            field: 'siteName',
            headerName: 'Site Adı',
            flex: 1,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'usagePurpose',
            headerName: 'Kullanım Amacı',
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: (params: any) => {
                return (
                    <div>
                        <Tooltip title={params.row.usagePurpose}>
                            <p>{params.row.usagePurpose}</p>
                        </Tooltip>
                    </div>
                );
            },
        },
        {
            field: 'usageTime',
            headerName: 'Kullanım Süresi',
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params: any) => {
                return (
                    <div>
                        <Tooltip title={params.row.usageTime}>
                            <p>{params.row.usageTime}</p>
                        </Tooltip>
                    </div>
                );
            },
        },
        {
            field: 'android',
            headerName: 'Android',
            renderHeader: () => (
                <div style={{ paddingLeft: '1rem' }}>
                    <AndroidIcon style={{ verticalAlign: 'middle', marginRight: 8 }} />
                    Android
                </div>
            ),
            width: 130,
            renderCell: (params) => (
                <Switch
                    checked={params.value}
                    color="primary"
                    readOnly
                    className={ckmCls(CKM.input, CKM.inputSwitch, CKM.gridSwitchAndroid)}
                />
            ),
        },
        {
            field: 'ios',
            headerName: 'iOS',
            renderHeader: () => (
                <div style={{ paddingLeft: '1rem' }}>
                    <AppleIcon style={{ verticalAlign: 'middle', marginRight: 8 }} />
                    iOS
                </div>
            ),
            width: 130,
            renderCell: (params) => (
                <Switch
                    checked={params.value}
                    color="primary"
                    readOnly
                    className={ckmCls(CKM.input, CKM.inputSwitch, CKM.gridSwitchIos)}
                />
            ),
        },
        {
            field: 'status',
            headerName: t('customerInformation.isActive'),
            width: 130,
            renderCell: (params) => (
                <Switch
                    checked={params.value}
                    color="primary"
                    readOnly
                    className={ckmCls(CKM.input, CKM.inputSwitch, CKM.gridSwitchStatus)}
                />
            ),
        },
        {
            field: 'deneme ',
            headerName: ' ',
            align: 'center',
            headerAlign: 'center',
            flex: 1,
            renderCell: (params: any) => {
                const handleClick = (popupState: any, tur: string) => {
                    popupState.close();
                    switch (tur) {
                        case 'gotoDetail': {
                            setSelectedCookie(params.row);
                            onDrawerOpen();
                            break;
                        }
                        case 'delete': {
                            let req: any = {};
                            req.cookieID = params.row.id;
                            req.status = false;
                            sil(req);

                            break;
                        }
                        default: {
                            break;
                        }
                    }
                };
                return (
                    <PopupState variant="popover" popupId="demo-popup-menu">
                        {(popupState: any) => (
                            <>
                                <IconButton
                                    {...bindTrigger(popupState)}
                                    className={ckmCls(CKM.input, CKM.inputIconButton, CKM.rowActionsTrigger)}
                                >
                                    {' '}
                                    <MoreVertIcon className="svg_icons" />{' '}
                                </IconButton>
                                <Menu {...bindMenu(popupState)}>
                                    <MenuItem
                                        className={ckmCls(CKM.input, CKM.inputMenuItem, CKM.rowActionEdit)}
                                        onClick={() => handleClick(popupState, 'gotoDetail')}
                                    >
                                        {t('general.edit')}{' '}
                                    </MenuItem>
                                    <MenuItem
                                        className={ckmCls(CKM.input, CKM.inputMenuItem, CKM.rowActionDelete)}
                                        onClick={() => handleClick(popupState, 'delete')}
                                    >
                                        {t('general.delete')}{' '}
                                    </MenuItem>
                                </Menu>
                            </>
                        )}
                    </PopupState>
                );
            },
        },
    ];
    const sil = async (params: any) => {
        const result = await Swal.fire({
            text: t('mobilePanel.deleteConfig'),
            cancelButtonText: t('general.cancel'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: t('general.delete'),
        });

        if (!result.isConfirmed) {
            return;
        }

        try {
            await CookieManagementCommand.DeleteCookie(params);
            Swal.fire('Silindi!', ' ', 'success');
            setRefresh((prevRefreshing) => !prevRefreshing);
        } catch (error: any) {
            console.log('Hata :>> ', error);
        }
    };
    const GetCookie = () => {
        CookieManagementQuery.ListOfCookie()
            .then((res: any) => {
                console.info(res.data);
                if (res) {
                    let parseData = res.data.map((item: any) => {
                        return {
                            id: item.cookieId,
                            cookieName: item.cookieName || '-',
                            siteName: item.siteName || '-',
                            cookieType: item.cookieType || '-',
                            usagePurpose: item.usagePurpose || '-',
                            android: item.android || false,
                            ios: item.ios || false,
                            status: item.status || false,
                            usageTime: item.usageTime || '-',
                            updateDate: (item.updateDate && TimeHelper.formatDate(item.updateDate)) || '-',
                            updateBy: item.updateBy || '-',
                        };
                    });
                    setCookie(parseData);
                }
            })
            .catch((error: any) => {
                console.log('Hata :>> ', error);
            })
            .finally(() => {});
    };
    const GetCookieType = () => {
        CookieManagementQuery.ListOfCookieType()
            .then((res: any) => {
                console.info(res.data);
                if (res) {
                    let parseData = res.data.map((item: any) => {
                        return {
                            id: item.cookieTypeId,
                            cookieTypeName: item.cookieTypeName || '-',
                            cookieTypeDescripton: item.cookieTypeDescripton || '-',
                            priority: item.priority || '-',
                            updateDate: (item.updateDate && TimeHelper.formatDate(item.updateDate)) || '-',
                            updateBy: item.updateBy || '-',
                        };
                    });
                    const parsedCookieTypeIdsAndNames = parseData.map((item: any) => ({
                        id: item.id,
                        name: item.cookieTypeName,
                    }));
                    setCookieTypeIdsAndNames(parsedCookieTypeIdsAndNames);
                }
            })
            .catch((error: any) => {
                console.log('Hata :>> ', error);
            })
            .finally(() => {});
    };
    return (
        <SCUIContent className={`${CKM.page} `}>
            <Grid
                className={CKM.titleArea}
                size={{
                    lg: 10,
                    md: 12,
                    xs: 12,
                }}
            >
                <h1 className="headtxt">{'Çerez Yönetimi Sayfası'}</h1>
            </Grid>
            <Grid
                className={CKM.toolbar}
                container
                justifyContent="flex-end"
                size={{
                    xs: 12,
                    sm: 12,
                }}
            >
                <SCUIButton
                    text={'Çerez Ekle'}
                    sizeType="fixed"
                    type="primary"
                    size={'l'}
                    className={ckmCls(CKM.input, CKM.inputButton, CKM.btnAddCookie)}
                    onClick={() => {
                        setSelectedCookie([]);
                        onDrawerOpen();
                    }}
                ></SCUIButton>
            </Grid>
            <SCUIGeneralDrawer
                open={state['right']}
                anchor="right"
                width={'80rem'}
                onClose={(event: any, reason: any) => {
                    if (reason === 'backdropClick') {
                        setState({ ...state, right: false });
                        //  setStateTrigger({ ...stateTrigger, right: false });
                    }
                }}
            >
                <SCUICookieManagementDrawerContent
                    selectedRow={selectedCookie}
                    onCloseMenu={onDrawerClose}
                    onUpdate={refreshSmsTemplate}
                    cookieType={cookieTypeIdsAndNames}
                />
            </SCUIGeneralDrawer>
            <Box className={CKM.datagrid}>
                <SCUICustomDataGrid randomId rows={cookie} columns={columns} />
            </Box>
        </SCUIContent>
    );
};
